import { Injectable } from '@angular/core';
import { Row } from '@vendasta/galaxy/table';
import { MatDialog } from '@angular/material/dialog';
import { SenderType } from '@vendasta/campaigns';
import { CrmCampaignContactsDialogComponent } from './crm-campaign-contacts-dialog.component';
import { GalaxyFilterInterface } from '@vendasta/galaxy/filter/chips';

@Injectable({ providedIn: 'root' })
export class CrmCampaignContactsDialogService {
  constructor(private dialog: MatDialog) {}

  openCampaignDialog(
    senderID: string,
    senderType: SenderType,
    rows: Row[],
    filters?: GalaxyFilterInterface[],
    search?: string,
    useSelectAll?: boolean,
    totalContacts?: number,
  ): void {
    this.dialog.open(CrmCampaignContactsDialogComponent, {
      data: { contacts: rows, senderId: senderID, senderType, filters, search, useSelectAll, totalContacts },
      width: '500px',
    });
  }
}
